import { createAsyncThunk } from '@reduxjs/toolkit'
import MetricInitialization from './metric-initialization-model'
import {
  delete_metricInitialization,
  load_metricInitializations,
  store_metricInitialization,
} from './metricInitialization-service'

export const LoadMetricInitializationsAsync = createAsyncThunk<any, any>(
  'composer/load/metricInitialization',
  async (params: { uid: string }) => {
    return await load_metricInitializations(params)
  },
)

export const CreateMetricInitializationAsync = createAsyncThunk<any, any>(
  'composer/create/metricInitialization',
  async (params: MetricInitialization) => {
    return await store_metricInitialization(params)
  },
)

export const DeleteMetricInitializationAsync = createAsyncThunk<any, any>(
  'composer/delete/metricInitialization',
  async (params) => {
    return await delete_metricInitialization(params)
  },
)
